import raw from "./trajectory.json";

/** [t, x, y, z, qw, qx, qy, qz] — a REAL closed-loop mission recorded from a
 * Workshop co-simulation: an FMU flight controller (radio → FC → ESC → motors
 * → props) closing the loop around rigid-body physics from Isaac Sim, captured
 * with exact sim-time stamps at 5 Hz and Catmull-Rom resampled to a uniform
 * 10 Hz. No keyframes. Mission: takeoff → 2 m hover → climb → 5 m hover →
 * controlled descent → touchdown, with a small honest lateral drift. */
export type TrajectorySample = [number, number, number, number, number, number, number, number];
export const TRAJECTORY = raw as TrajectorySample[];
export const REPLAY_SPEED = 2.0;
/** Replay window: the recording runs 69.6 s but the drone touches down at
 * t≈60 and then sits landed. The loop replays through touchdown plus ~2 s of
 * rest (t=62) and cuts the static tail — still 1:1 data, just a declared cut.
 * At 2× that's a ~31 s visual loop. */
export const REPLAY_WINDOW_END = 62;
export const PROVENANCE =
  "Real closed-loop mission — takeoff, 2 m hover, climb to 5 m, descent, landing. FMU flight controller + Isaac Sim physics, recorded co-sim states resampled to 10 Hz · 2× playback · no keyframes.";
